import { z } from "zod";
import { MemberRol } from "./ClientUser";

export enum ClientUserInvitationStatus {
  PENDING = "PENDING",
  USED = "USED",
  EXPIRED = "EXPIRED",
}

export const InvitationDTO = z.object({
  id: z.string(),
  status: z.nativeEnum(ClientUserInvitationStatus),
  expirationDate: z.string().transform((date) => new Date(date)),
  businessName: z.string().optional(),
  memberId: z.string().optional(),
  email: z.string().optional(),
  domainEvents: z.any().array().optional(),
  phone: z.string().optional(),
  name: z.string().optional(),
  rol: z.nativeEnum(MemberRol).optional(),
});

export type Invitation = z.infer<typeof InvitationDTO>;
